const state = {
  organisations: [],
  organisation: {},
  loaded: false
};

export default state;
